<template>
  <div id="calculator">
    <b-container class="calculator">
        <b-row v-if="!agreeVal" class="mt-5 mb-5 pt-5 pb-5">
          <b-col class="text-center">
            <span v-if="this.languagesAvailable.nl" @click="languageSelect('nl')" class="mr-5">
              <country-flag country='nl' size='big'/>
            </span>
            <span v-if="this.languagesAvailable.en" @click="languageSelect('en')" class="mr-5">
              <country-flag country='gb' size='big'/>
            </span>
            <span v-if="this.languagesAvailable.de" @click="languageSelect('de')" class="mr-5">
              <country-flag country='de' size='big'/>
            </span>
            <span v-if="this.languagesAvailable.fr" @click="languageSelect('fr')" class="mr-5">
              <country-flag country='fr' size='big'/>
            </span>
          </b-col>
        </b-row>
        
        <b-row v-if="!agreeVal">
          <b-col class="text-center">
            {{ translations['disclaimer'] }}
          </b-col>
        </b-row>
        
        <b-row v-if="!agreeVal">
          <b-col class="text-center">
            <b-alert class="mt-3" variant="danger" v-if="disagreeVal" show>
              {{ translations['disagreeText'] }}
            </b-alert>
          </b-col>
        </b-row>
        <b-row v-if="!agreeVal">
          <b-col>
            <b-btn class="mt-4 spccButton" block v-on:click="agreePressed()">{{ translations['agree'] }}</b-btn>
          </b-col>
          <b-col></b-col>
          <b-col>
            <b-btn class="mt-4 spccButton" block v-on:click="disagreePressed()">{{ translations['disagree'] }}</b-btn>
          </b-col>
        </b-row>

        <!-- INPUT -->
        <b-row v-if="agreeVal && !calculation" class="pb-5 mb-5">
          <b-btn class="spccButton" block v-on:click="resetCalculation()">{{ translations['newCalculation'] }}</b-btn>

          <div role="tablist" class="pt-4 list" width="100%">

              <b-card no-body class="mb-1" v-for="(item, key) in input" v-if="item.visible" :key="'card_'+key">
                <b-card-header header-tag="header" class="p-0" role="tab" v-bind:class="{ invalidSmall: item.required && item.value === false }">
                  <b-btn class="p-2" v-bind:class="{ spccButton : item.disp_value !== false, initialColor : item.disp_value === false }" block href="#" v-b-toggle="key">{{ translations[key] }} <span v-if="item.disp_value !== false">{{ item.disp_value }}</span></b-btn>
                </b-card-header>
                <b-collapse :id="key" accordion="spcc_inputs" role="tabpanel" :visible="currentInput==key">
                  <b-card-body>
                    <b-form-input v-on:change="change(key)" :id="'input_'+key"
                        type="text"
                        v-model="item.value"
                        :required="item.required"
                        v-if="item.inputtype=='text'" autofocus>
                    </b-form-input>

                    <b-form-input v-on:change="change(key)" :id="'input_'+key"
                        type="email"
                        v-model="item.value"
                        :required="item.required"
                        v-if="item.inputtype=='email'" autofocus>
                    </b-form-input>

                    <b-form-input v-on:change="change(key)" :id="'input_'+key"
                        type="number"
                        v-model="item.value"
                        :required="item.required"
                        v-if="item.inputtype=='number'" autofocus>
                    </b-form-input>

                    <b-form-select v-on:change="change(key)" :id="'input_'+key"
                        :options="item.values"
                        :required="item.required"
                        v-model="item.value"
                        v-if="item.inputtype=='select'" autofocus>
                    </b-form-select>
                  </b-card-body>
                </b-collapse>
              </b-card>
          </div>

          <b-btn class="spccButton" block v-on:click="doCalculation()" v-if="requiredPassed">{{ translations['doCalculation'] }}</b-btn>
          <!-- <div v-if="!requiredPassed">
            <h2 class="mt-3 mb-0">{{ translations['requiredCheck'] }}:</h2>
            <div v-for="(value, key) in input">
              <div v-if="!itemPassed(key)">
                {{ translations[key] }}
              </div>
            </div>
          </div> -->
        </b-row>

        <!-- RESULT -->
        <b-row v-if="agreeVal && calculation && !sent_email">
          <b-col>
            <b-btn class="spccButton" block v-on:click="calculation = false">{{ translations['back'] }}</b-btn>

            <h1 class="mt-5" v-if="input.projectnaam.value">{{ translations['projectnaam'] }}: {{ input.projectnaam.value }}</h1>
            <h2 class="mb-0 mt-3">{{ translations['profileCalculation'] }}:</h2>
            <p class="mb-2">{{ results.profile }}</p>
            <h2 class="mb-5">{{ translations['dimensions'] }}:</h2>
          </b-col>
        </b-row>
        <b-row v-if="agreeVal && calculation && !sent_email">
          <b-col>
            <b-img :src="results.px" fluid-grow :alt="results.profile" />
          </b-col>
        </b-row>
        <b-row v-if="agreeVal && calculation && !sent_email">
          <b-col>
            <h3 class="mb-2">{{ translations['inputValues'] }}:</h3>
            <table class="mb-5 table resultTable">
              <tr v-for="(item, key) in inputOrdered" v-if="showResultInput(key)">
                <td>
                  {{ translations[key] }}
                </td>
                <td>
                  <b-form-input @input="change(key)" @change="change(key)" :id="'input_'+key"
                      type="text"
                      v-model="item.value"
                      :required="item.required"
                      v-if="item.inputtype=='text'">
                  </b-form-input>

                  <b-form-input @input="change(key)" @change="change(key)" :id="'input_'+key"
                      type="email"
                      v-model="item.value"
                      :required="item.required"
                      v-if="item.inputtype=='email'">
                  </b-form-input>

                  <b-form-input @input="change(key)" @change="change(key)" :id="'input_'+key"
                      type="number"
                      v-model="item.value"
                      :required="item.required"
                      v-if="item.inputtype=='number'">
                  </b-form-input>

                  <b-form-select @input="change(key)" @change="change(key)" :id="'input_'+key"
                      :options="item.values"
                      :required="item.required"
                      v-model="item.value"
                      v-if="item.inputtype=='select'">
                  </b-form-select>
                  <p class="mb-0" v-if="item.inputtype=='display'" v-html="item.value">{{ item.value }}</p>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <b-row v-if="agreeVal && calculation && !sent_email">
          <b-col>
              <h3 class="mb-2">{{ translations['result'] }}:</h3>
              <table class="table resultTable">
                <tr>
                  <th>{{ translations['description'] }}</th>
                  <th>{{ translations['startvalues'] }}</th>
                  <th>{{ translations['endvalues'] }}</th>
                </tr>
                <tr>
                  <td>{{ translations['w'] }}</td>
                  <td v-html="results.w">{{ results.w }}</td>
                  <td v-html="results.w_nieuw">{{ results.w_nieuw }}</td>
                </tr>

                <tr>
                  <td>{{ translations['i_app'] }}</td>
                  <td v-html="results.i_app">{{ results.i_app }}</td>
                  <td v-html="results.i_app_nieuw">{{ results.i_app_nieuw }}</td>
                </tr>

                <tr>
                  <td>{{ translations['o_cmm'] }}</td>
                  <td v-html="results.o_cmm">{{ results.o_cmm }}</td>
                  <td v-html="results.o_cmm_nieuw">{{ results.o_cmm_nieuw }}</td>
                </tr>

                <tr>
                  <td>{{ translations['tf'] }}</td>
                  <td v-html="results.tf">{{ results.tf }}</td>
                  <td v-html="results.tf_nieuw">{{ results.tf_nieuw }}</td>
                </tr>

                <tr>
                  <td>{{ translations['tw'] }}</td>
                  <td v-html="results.tw">{{ results.tw }}</td>
                  <td v-html="results.tw_nieuw">{{ results.tw_nieuw }}</td>
                </tr>

                <tr>
                  <td>{{ translations['a_cm2m'] }}</td>
                  <td v-html="results.a_cm2m">{{ results.a_cm2m }}</td>
                  <td v-html="results.a_cm2m_nieuw">{{ results.a_cm2m_nieuw }}</td>
                </tr>
                <tr>
                  <td>{{ translations['restpercentage'] }}</td>
                  <td>100 %</td>
                  <td v-html="results.restpercentage_nieuw">{{ results.restpercentage_nieuw }}</td>
                </tr>
              </table>
          </b-col>
        </b-row>
        <b-row v-if="agreeVal && calculation && !sent_email">
          <b-col>
            <b-btn class="spccButton" block v-on:click="resetCalculation()">{{ translations['newCalculation'] }}</b-btn>
          </b-col>
        </b-row>
        <b-row v-if="agreeVal && calculation && !sent_email" v-bind:class="{ 'pb-5 mb-5': !showEmailCalculation }">
          <b-col>
            <h3 class="mt-5">{{ translations['invalidOptinText'] }}</h3>
            <table class="table">
              <tr>
                <td>{{ translations['emailadres'] }}</td>
                <td>
                  <b-form-input @change="change('emailadres')" @input="change('emailadres')" :id="'input_emailadres'"
                    type="email"
                    v-model="input['emailadres'].value"
                    :required="input['emailadres'].required">
                  </b-form-input>
                </td>
              </tr>
              <tr>
                <td>{{ translations['optin'] }}</td>
                <td>
                  <b-form-select @change="change('optin')" @input="change('optin')" :id="'input_optin'"
                      :options="input['optin'].values"
                      :required="input['optin'].required"
                      v-model="input['optin'].value"
                      v-bind:class="{ invalid: input.optin.value==0 }">
                  </b-form-select>
                </td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <b-row v-if="showEmailCalculation" class="pb-5 mb-5">
          <b-col>
            <b-btn class="spccButton" block v-on:click="emailCalculation()">{{ translations['emailCalculation'] }}</b-btn>
          </b-col>
        </b-row>

        <!-- Confirmpage -->
        <b-row v-if="agreeVal && calculation && sent_email">
          <b-col>
            <b-btn class="spccButton mb-5" block v-on:click="sent_email = false">{{ translations['back'] }}</b-btn>
            <b-alert variant="success" show v-if="!this.confirm.error">{{ this.confirm.message }}</b-alert>
            <b-alert variant="danger" show v-if="this.confirm.error">{{ this.confirm.message }}</b-alert>
            <b-btn class="spccButton mt-5" block v-on:click="resetCalculation()">{{ translations['newCalculation'] }}</b-btn>
          </b-col>
        </b-row>
    </b-container>
    <div v-if="loading" class="loading">
      <b-container>
        <b-row align-v="center">
          <b-col align-self="center" class="text-center">
            <div class="loadingText animated pulse infinite">{{ translations['loading'] }}...</div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import translation_nl from './assets/translations.json'
import translation_en from './assets/translations_en.json'
import translation_de from './assets/translations_de.json'
import translation_fr from './assets/translations_fr.json'
export default {
  name: 'Calculator',
  props: ['layout', 'languages'],
  data () {
    return {
      agreeVal : false,
      disagreeVal : false,
      calculation : false,
      sent_email: false,
      loading : false,
      language : 'nl',
      currentInput : '',
      translationsFiles : {
        'nl' : translation_nl,
        'en' : translation_en,
        'de' : translation_de,
        'fr' : translation_fr,
      },
      result : {},
      confirm: {},
      lifespanNext : '',
      protectionvalues: false,
      values : {
        profiletype: {
          visible : true,
          inputtype    : 'select',
          value   : false,
          disp_value   : false,
          values  : {},
          required: true,
        },
        profile_id: {
          visible     : true,
          inputtype   : 'select',
          value       : false,
          values  : {},
          required: true,
        },
        steelquality_id: {
          visible : true,
          inputtype    : 'select',
          value   : false,
          disp_value   : false,
          values  : {

          },
          required: true,
        },
        protectionfront: {
          visible : true,
          inputtype    : 'select',
          value   : 0,
          values  : {},
          required: true,
        },
        protectionback: {
          visible : true,
          inputtype    : 'select',
          value   : 0,
          values  : {},
          required: true,
        },
        norm_id:{
          visible : true,
          inputtype    : 'select',
          value   : false,
          disp_value   : false,
          values  : {

          },
          required: true,
        },
        lifespan: {
          visible   : false,
          inputtype : 'select',
          value     : false,
          values    : {

          },
          required  : true,
        },
        front_corrosion_id: {
          visible   : false,
          inputtype : 'select',
          value     : false,
          values    : {

          },
          required  : true,
        },
        front_mm_total: {
          visible   : false,
          inputtype : 'number',
          value     : false,
          values    : {

          },
          required  : true,
        },
        front_mm_rate: {
          visible   : false,
          inputtype : 'number',
          value     : false,
          values    : {

          },
          required  : true,
        },
        back_corrosion_id: {
          visible   : false,
          inputtype : 'select',
          value     : false,
          values    : {

          },
          required  : true,
        },
        back_mm_total: {
          visible   : false,
          inputtype : 'number',
          value     : false,
          values    : {

          },
          required  : true,
        },
        back_mm_rate: {
          visible   : false,
          inputtype : 'number',
          value     : false,
          values    : {

          },
          required  : true,
        },
        projectnaam: {
          visible : true,
          inputtype    : 'text',
          value   : '',
          disp_value   : false,
          values  : {

          },
          required: false,
        },
        naam: {
          visible : true,
          inputtype    : 'text',
          value   : '',
          disp_value   : false,
          values  : {

          },
          required: false,
        },
        firma: {
          visible : true,
          inputtype    : 'text',
          value   : '',
          disp_value   : false,
          values  : {

          },
          required: false,
        },
        emailadres: {
          visible : true,
          inputtype    : 'email',
          value   : '',
          disp_value   : false,
          values  : {

          },
          required: false,
        },
        optin: {
          visible : true,
          inputtype    : 'select',
          value   : false,
          disp_value   : false,
          values  : {

          },
          required: true,
        }
      }
    }
  },
  computed: {
    input : function(){ 
      return this.values;
    },
    languagesAvailable : function(){
      var languages = {
        'nl' : this.inArray('nl', this.languages),
        'en' : this.inArray('en', this.languages),
        'de' : this.inArray('de', this.languages),
        'fr' : this.inArray('fr', this.languages),
      };

      return languages;
    },
    showEmailCalculation : function(){
      if(!this.agreeVal){
        return false;
      }
      if(!this.calculation){
        return false;
      }
      if(this.optin == 0){
        return false;
      }
      if(this.sent_email){
        return false;
      }
      if(!this.input.emailadres.value){
        return false;
      }
      return true;
    },
    inputOrdered : function(){
      var ordered = [
                      'profiletype',
                      'profile_id',
                      'g_kgm2',

                      'steelquality_id',
                      'lifespan',
                      'norm_id',
                      'front_corrosion_id',
                      'front_mm_total',
                      'front_mm_rate',
                      'back_corrosion_id',
                      'back_mm_total',
                      'back_mm_rate',

                      'protectionfront',
                      'protectionback',
                      'corrosiontotal_front',
                      'corrosiontotal_back',
                    ];
      var returnvalues = {};

      for(let index in ordered){
        let item = ordered[index];
        let val = '';
        if(item=='g_kgm2'){
          val = {
                  visible     : true,
                  inputtype   : 'display',
                  value       : this.results[item],
                  values      : {},
                  required    : false,
                };
        }else if(item=='corrosiontotal_front'){
          val = {
                  visible     : true,
                  inputtype   : 'display',
                  value       : this.results[item],
                  values      : {},
                  required    : false,
                };
        }else if(item=='corrosiontotal_back'){
          val = {
                  visible     : true,
                  inputtype   : 'display',
                  value       : this.results[item],
                  values      : {},
                  required    : false,
                };
        }else{
          val = this.values[item];
        }
        returnvalues[item] = val;
      }
      return returnvalues;
    },
    currentLanguage : function(){
      return this.language;
    },
    translations : function(){
      return this.translationsFiles[this.language];
    },
    protection : function(){
      return this.protectionvalues;
    },
    requiredPassed : function(){
      var passed = true
      
      for(let item in this.values){
        if(this.values[item].required){
          if(this.values[item].value === false){
            return false;
          }
        }
      }
      return passed;
    },
    results : function(){
      return this.result;
    }
  },
  methods:{
    inArray: function(needle, haystack) {
      var length = haystack.length;
      for(var i = 0; i < length; i++) {
          if(haystack[i] == needle) return true;
      }
      return false;
    },
    itemPassed : function(item){
      if(this.values[item].visible){
        if(this.values[item].required){
          if(this.values[item].value === false){
            return false;
          }
        }
      }
      return true
    },
    resetCalculation(){
      for(let item in this.values){
        this.values[item].value = false;
        this.values[item].disp_value = false;
      }
      this.values['protectionfront'].value      = 0;
      this.values['protectionfront'].disp_value = 0 + ' ' + this.translations['year'];
      this.values['protectionback'].value      = 0;
      this.values['protectionback'].disp_value = 0 + ' ' + this.translations['year'];
      this.currentInput = 'profiletype';

      this.sent_email = false;
      this.calculation = false;
    },
    disagreePressed(){
      this.agreeVal = false;
      this.disagreeVal = true;
    },
    'agreePressed': function(){
      this.agreeVal = true;
      this.disagreeVal = false;
      // this.demo();
    },
    languageSelect(lang){
      this.language = lang;
      this.getTranslations();
    },
    change(value){
      switch(value) {
        case 'profiletype':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.values.profile_id.value = false;
            this.values.profile_id.disp_value = false;
            this.profielenApi(document.getElementById('input_'+value).value);
          break;
        case 'profile_id':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.currentInput = 'steelquality_id';
          break;
        case 'steelquality_id':
          this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.currentInput = 'norm_id';
          break;
        case 'norm_id':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            let norm_id = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].value;
            axios.get('https://api.sheetpilecorrosioncalculator.com/api/norm/'+norm_id)
                  .then(response => {
                    let normdata = response.data.data;
                    let normSelects = ['lifespan', 'front_mm_rate', 'front_mm_total', 'front_corrosion_id', 'back_mm_rate', 'back_mm_total', 'back_corrosion_id'];
                    this.lifespanNext = 'front_mm_total';
                    for(let item in normdata){
                      if(normSelects.indexOf(item)>=0){
                        if(normdata[item] == 0){
                          this.values[item].visible = false;
                          this.values[item].value = false;
                          this.values[item].disp_value = false;
                          this.values[item].required = false;
                        }else{
                          this.values[item].required = true;
                          this.values[item].visible = true;
                          if(this.values['lifespan'].visible){
                            if(item=='front_mm_total'){
                              this.lifespanNext = 'front_mm_total';
                            }
                            if(item=='front_mm_rate'){
                              this.lifespanNext = 'front_mm_rate';
                            }
                            if(item=='front_corrosion_id'){
                              this.lifespanNext = 'front_corrosion_id';
                            }
                          }
                        }
                      }
                    }
                    this.normValues();
                    if(this.values['lifespan'].visible){
                      this.currentInput = 'lifespan';
                    }else{
                      this.currentInput = 'front_mm_total';
                    }
                  })
                  .catch(error => {
                    console.log(error);
                  });
          break;

        case 'lifespan':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            this.currentInput = this.lifespanNext;
          break;

        case 'front_corrosion_id':
            var corrosion_str = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            if(corrosion_str.length>35){
              corrosion_str = corrosion_str.substr(0,35) + '...';
            }
            this.values[value].disp_value = corrosion_str;
            this.currentInput = 'back_corrosion_id';
          break;

        case 'back_corrosion_id':
            var corrosion_str = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
            if(corrosion_str.length>35){
              corrosion_str = corrosion_str.substr(0,35) + '...';
            }
            this.values[value].disp_value = corrosion_str;
            this.currentInput = 'projectnaam';
          break;

        case 'front_mm_total':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'back_mm_total';
          break;

        case 'back_mm_total':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'projectnaam';
          break;

        case 'front_mm_rate':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'back_mm_rate';
          break;

        case 'back_mm_rate':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'projectnaam';
          break;

        case 'projectnaam':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'naam';
          break;

        case 'naam':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'firma';
          break;

        case 'firma':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'emailadres';
          break;

        case 'emailadres':
            this.values[value].disp_value = document.getElementById('input_'+value).value.toString();
            this.currentInput = 'optin';
          break;

        case 'optin':
            this.values[value].disp_value = document.getElementById('input_'+value)[document.getElementById('input_'+value).selectedIndex].text;
          break;

        default:
            console.log('change', value);
          break;
      }

      if(this.calculation){
        this.doCalculation();
      }
    },
    profielenApi(profiletype){
      if(!profiletype){
        this.currentInput = 'profiletype';
        return false;
      }

      if(profiletype==3 || profiletype==5){
        profiletype = 1;
      }
      if(profiletype==4 || profiletype==6){
        profiletype = 2;
      }
      axios.get('https://api.sheetpilecorrosioncalculator.com/api/profielen/'+profiletype+'/'+this.layout)
            .then(response => {
              var profiles = new Array();
              for (var i = 0; i < response.data.data.length; i++) {
                let id = response.data.data[i].id;
                let name = response.data.data[i].name;
                profiles[id] = {'value' : id, 'text' : name};
              }
              this.values.profile_id.values = profiles;
              this.currentInput = 'profile_id';
            })
            .catch(error => {
              console.log(error);
            })
    },
    normValues(){
      var norm_id = this.values.norm_id.value;
      axios.get('https://api.sheetpilecorrosioncalculator.com/api/normwaarden/'+norm_id)
          .then(response => {
            var normvalues = new Array();
            for (var i = 0; i < response.data.data.length; i++) {
              let id = response.data.data[i].id;
              let name = response.data.data[i].name;
              normvalues[id] = {'value' : id, 'text' : name};
            }

            this.values.front_corrosion_id.values = normvalues;
            this.values.back_corrosion_id.values = normvalues;

          })
          .catch(error => {
            console.log(error);
          });
    },
    getTranslations(language){
      var language = this.language;
      axios.get('https://api.sheetpilecorrosioncalculator.com/api/normen/'+language)
          .then(response => {
            var norm = new Array();
            for (var i = 0; i < response.data.data.length; i++) {
              let id = response.data.data[i].id;
              let name = response.data.data[i].name;
              norm[id] = {'value' : id, 'text' : name};
            }
            this.values.norm_id.values = norm;
          })
          .catch(error => {
            console.log(error);
          });

      axios.get('https://api.sheetpilecorrosioncalculator.com/api/profieltypen/'+language)
            .then(response => {
              var profiletype = new Array();
              for (var i = 0; i < response.data.data.length; i++) {
                let id = response.data.data[i].id;
                let name = response.data.data[i].name;
                profiletype[id] = {'value' : id, 'text' : name};
              }
              this.values.profiletype.values = profiletype;
            })
            .catch(error => {
              console.log(error);
            });

      let lifespanValues = [];
      for(var i=0; i<=100; i++){
        lifespanValues.push({value : i, text: i + ' ' + this.translations['year']});
        i = i+4;
      }
      this.values['lifespan'].values = lifespanValues;

      this.protectionvalues =  [
        {value : 0, text: 0 + ' ' + this.translations['year']},
        {value : 1, text: 1 + ' ' + this.translations['year']},
        {value : 2, text: 2 + ' ' + this.translations['year']},
        {value : 3, text: 3 + ' ' + this.translations['year']},
        {value : 4, text: 4 + ' ' + this.translations['year']},
        {value : 5, text: 5 + ' ' + this.translations['year']},
        {value : 6, text: 6 + ' ' + this.translations['year']},
        {value : 7, text: 7 + ' ' + this.translations['year']},
        {value : 8, text: 8 + ' ' + this.translations['year']},
        {value : 9, text: 9 + ' ' + this.translations['year']},
        {value : 10, text: 10 + ' ' + this.translations['year']},
        {value : 11, text: 11 + ' ' + this.translations['year']},
        {value : 12, text: 12 + ' ' + this.translations['year']},
        {value : 13, text: 13 + ' ' + this.translations['year']},
        {value : 14, text: 14 + ' ' + this.translations['year']},
        {value : 15, text: 15 + ' ' + this.translations['year']},
        {value : 16, text: 16 + ' ' + this.translations['year']},
        {value : 17, text: 17 + ' ' + this.translations['year']},
        {value : 18, text: 18 + ' ' + this.translations['year']},
        {value : 19, text: 19 + ' ' + this.translations['year']},
        {value : 20, text: 20 + ' ' + this.translations['year']},
      ];
      this.values['protectionfront'].values = this.protectionvalues;
      this.values['protectionback'].values = this.protectionvalues;
      this.normValues();

      this.values['optin'].values = [
        {value : 0, text: this.translations['disagree']},
        {value : 1, text: this.translations['agree']},
      ];
    },
    doCalculation: function(){
      this.calculation = true;

      var post = {};
      for(var item in this.values){
        post[item] = this.values[item].value;
      }
      post['layout'] = this.layout;
      post['language'] = this.language;
    
      axios.post('https://api.sheetpilecorrosioncalculator.com/api/calculator', post)
          .then(response => {
            this.result = response.data.result;
          })
          .catch(error => {
            console.log(error);
          });
      
    },
    emailCalculation: function(){
      this.loading = true;
      var post = {};
      for(var item in this.values){
        post[item] = this.values[item].value;
      }
      post['sent_email']  = true;
      post['layout']      = this.layout;
      post['language']    = this.language;
      
      axios.post('https://api.sheetpilecorrosioncalculator.com/api/calculator', post)
          .then(response => {
            this.confirm = response.data;
            this.sent_email = true;
            this.loading = false;
          })
          .catch(error => {
            this.confirm.error = true;
            this.confirm.message = this.translations['error'];
            this.sent_email = true;
            this.loading = false;
            console.log(error);
          });
      
    },
    showResultInput: function(key){
      var inputKeys = [
                        'profiletype',
                        'profile_id',
                        'steelquality_id',
                        'protectionfront',
                        'protectionback',
                        'norm_id',
                        'lifespan',
                        'front_corrosion_id',
                        'front_mm_total',
                        'front_mm_rate',
                        'back_corrosion_id',
                        'back_mm_total',
                        'back_mm_rate',
                      ];

      var resultKeys = [
                        'g_kgm2',
                        'corrosiontotal_front',
                        'corrosiontotal_back',
                      ];

      if(resultKeys.indexOf(key)>=0){
        return true;
      }

      if(inputKeys.indexOf(key)>=0){
        if(this.values[key].visible){
          return true;
        }
      }
      return false;
    },
    demo(){
      this.agreeVal = true;
      this.values['profiletype'].value = '2',
      this.values['profile_id'].value = '63',
      this.values['steelquality_id'].value = '3',
      this.values['protectionfront'].value = '0',
      this.values['protectionback'].value = '0',
      this.values['norm_id'].value = '5',
      this.values['norm_id'].visible = true,
      this.values['lifespan'].value = '30',
      this.values['lifespan'].visible = true,
      this.values['front_corrosion_id'].value = '31',
      this.values['front_corrosion_id'].visible = true,
      this.values['front_mm_total'].value = false,
      this.values['front_mm_rate'].value = false,
      this.values['back_corrosion_id'].value = '37',
      this.values['back_corrosion_id'].visible = true,
      this.values['back_mm_total'].value = false,
      this.values['back_mm_rate'].value = false,
      this.values['projectnaam'].value = '',
      this.values['naam'].value = '',
      this.values['firma'].value = '',
      this.values['emailadres'].value = '',
      this.values['optin'].value = '1',

      this.normValues();
      this.profielenApi(2);
      this.getTranslations();
      this.doCalculation();
    }
  },
  mounted: function(){
    this.getTranslations();
    this.resetCalculation();

    axios.get('https://api.sheetpilecorrosioncalculator.com/api/staalkwaliteiten')
          .then(response => {
            var steel = new Array();
            for (var i = 0; i < response.data.data.length; i++) {
              let id = response.data.data[i].id;
              let name = response.data.data[i].name;
              steel[id] = {'value' : id, 'text' : name};
            }
            this.values.steelquality_id.values = steel;
          })
          .catch(error => {
            console.log(error);
          });
  },

}
</script>

<style>
  #app{
    min-height:100vh;
    width:100vw;
    background-color: #FFF;
    color: #024788;
    max-width: 768px;
    margin: 0 auto;
  }
</style>


// WEBPACK FOOTER //
// src/Calculator.vue